import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import { List, Avatar } from '@material-ui/core';
import EventAvatar from './EventAvatar';
import deepOrange from '@material-ui/core/colors/deepOrange';
import deepPurple from '@material-ui/core/colors/deepPurple';
import amber from '@material-ui/core/colors/amber'
import brown from '@material-ui/core/colors/brown';
import { Link } from 'react-router-dom';
import Home from '@material-ui/icons/Home';
import Document from '@material-ui/icons/Archive'
import Paper from '@material-ui/core/Paper';
import {Typography} from "@material-ui/core";



const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    legend: {
        margin: 10,
        padding: theme.spacing.unit,
        backgroundColor: "#FAFAFA",
    },
    nested: {
        paddingLeft: theme.spacing.unit,
    },
    orangeAvatar: {
        backgroundColor: deepOrange[500],
    },
    purpleAvatar: {
        backgroundColor: deepPurple[500],
    },
    amberAvatar: {
        backgroundColor: amber[500],
    },
    brownAvatar: {
        backgroundColor: brown[500],
    },
    primary: {},
    icon: {},
    secondary: {},
    selected: {
        '& $primary': {
            color: theme.palette.primary.main,
        },
    },
    notselected: {},
    toolbar: theme.mixins.toolbar,
});

class EventsList extends React.Component {
    state = { open: true, selected: -1, subItemSelected: -1,};

    handleClick = () => {
      this.setState({ open: !this.state.open });
      
    };
  
    handleChildClick = (theTitle,subTitle,index,subindex) => {
      this.props.updateTitle(theTitle,subTitle,index,subindex);
      this.setState({ selected: index, subItemSelected: subindex });
    }
  
    render() {
      const { classes,events,eventId,detailId } = this.props;
      const bull = <span className={classes.bullet}>•</span>;
      return (
          
        <div className={classes.root}>
          
            <Divider />
            
            {events.map((item,itemKey) => {
                if (item.id === 1) {
                    return (
                        <div key={itemKey}>
                            <ListItem>
                                <Avatar className={classes.purpleAvatar}>
                                    <EventAvatar itemKey={itemKey}/>
                                </Avatar>
                                <ListItemText classes={{ primary: classes.primary }} primary={item.description} key={item.itemKey} secondary={item.when}/>
                                
                            </ListItem>
                            
                            <List component="div" disablePadding>
                                {item.eventDetails.map((prop, propKey) => {
                                    // return (
                                    //     <div className={classes.nested} key={prop.description}>
                                    //         <EventPre showAvatar={false} item={prop} key={propKey} updateTitle={(theTitle) => {this.props.updateTitle(theTitle)}} />
                                    //     </div>
                                    // );
                                    return (
                                        <div className={classes.nested} key={prop.description}>
                                        <ListItem button key={propKey} className={this.state.subItemSelected === -1 ? (prop.id === detailId ? classes.selected : classes.notselected) : (prop.id === this.state.subItemSelected ? classes.selected : classes.notselected)} component={Link} to={`/event-schedule/event/1/${prop.id}`} onClick={() => this.handleChildClick(item.description,prop.alias,item.id,prop.id)}>
                                            <ListItemText inset key={propKey} classes={{ primary: classes.primary }} primary={prop.description}/>
                                        </ListItem>
                                        </div>
                                    );
                                })}
                            </List>
                        </div>
                    );
                }
                else {
                    // return (
                    //     <EventDay showAvatar={true} item={item} key={itemKey} updateTitle={(theTitle) => {this.props.updateTitle(theTitle)}} />
                    // );
                    return (
                        
                        <ListItem button className={this.state.selected === -1 ? (item.id === eventId ? classes.selected : classes.notselected) : (item.id === this.state.selected ? classes.selected : classes.notselected)} key={itemKey} component={Link} to={`/event-schedule/event/${item.id}`} onClick={() => this.handleChildClick(item.description,item.when,item.id,NaN)}>
                            <Avatar className={classes.orangeAvatar}>
                                <EventAvatar itemKey={itemKey}/>
                            </Avatar>
                            <ListItemText classes={{ primary: classes.primary, secondary: classes.secondary }} primary={item.description} key={item.itemKey} secondary={item.when} />   
                        </ListItem>
                        
                    );
                }
                
            })}

            <Divider />
            <List component="nav">
                
                <ListItem button component="a" href="https://www.seatingsymposium.us">
                    <Avatar className={classes.brownAvatar}>
                        <Home />
                    </Avatar>
                    <ListItemText primary="ISS 2025 Homepage" />
                </ListItem>

                <ListItem button component="a" href="https://www.seatingsymposium.us/wp-content/uploads/documents/ISS2025_Program-Schedule.pdf">
                    <Avatar className={classes.amberAvatar}>
                        <Document />
                    </Avatar>
                    <ListItemText primary="ISS 2025 Program Schedule" />
                </ListItem>
                
            </List>

            <Paper className={classes.legend} elevation={1}>
                <Typography component="p">
                    <ul>
                        <li>SS: Special Session (60 min.)</li>
                        <li>IC: Instructional Course (60 min.)</li>
                        <li>IW: Interactive Workshop (90 min.)</li>
                        <li>SC: Short Course (30 min.)</li>
                        <li>PS: Paper Session (15 min.)</li>
                        <li>PO: Poster Session (60 min.)</li>
                        <li>PC: Pre-conference Workshop (4/8 hrs.)</li>
                    </ul>
                </Typography>
            </Paper>
        </div>
      );
    }
}

EventsList.propTypes = {
    classes: PropTypes.object.isRequired,
    updateTitle: PropTypes.func,
    events:PropTypes.array.isRequired,
    eventId: PropTypes.number,
    detailId: PropTypes.number,
};

export default withStyles(styles)(EventsList);